import { AxiosError, AxiosResponse } from 'axios';
import { useMutation, UseMutationResult } from 'react-query';
import { SetPasswordRequest } from 'types';
import { client } from 'utils/api-client';

export default function useResetPasswordConfirm(): UseMutationResult<
  AxiosResponse<void>,
  AxiosError<{ message: string }>,
  SetPasswordRequest
> {
  return useMutation(request => client.post('/auth/reset-password-confirm/', request));
}
